import { FIELD_UPDATE_SOURCE } from "../constants";

interface AccrualAccountLine {
    amount: number;
    accountId: string | null;
    accountIdSource?: FIELD_UPDATE_SOURCE | null;
}

export function isUnconfirmedAccrualAccountLine(
    line: AccrualAccountLine,
): boolean {
    return (
        line.amount !== 0 &&
        line.accountId !== null &&
        line.accountIdSource === FIELD_UPDATE_SOURCE.ACCRUAL_DEFAULT_ACCOUNTS
    );
}
